// extracted by mini-css-extract-plugin
module.exports = {"styledSubmitButton":"wy2cqZQe"};